import React from 'react';
import styles from './style.module.scss';

export interface FpUserButtonProps {
}

export function FpUserButton(props: FpUserButtonProps) {
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      className={`${styles['user-button']} k-button k-button-md k-button-solid k-button-solid-base`}
      type="button"
    >
      <span className="k-icon k-i-user" />
    </button>
  );
}
